import { render, staticRenderFns } from "./tipdia.vue?vue&type=template&id=0d4e4d06&"
import script from "./tipdia.vue?vue&type=script&lang=js&"
export * from "./tipdia.vue?vue&type=script&lang=js&"
import style0 from "./tipdia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports